if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const $btn = $('.product-form__buttons #umoq-add-to-cart-btn');
        const $allBtns = $('.product-form__buttons button');
        const $disable = $('unitmoq-product-details, product-form');
        const original = $btn.text();
        $allBtns.prop('aria-disabled', true);
        $disable.addClass('loading');
        $btn.text('Adding…');
        const prodObj = $('.product')?.data('obj');
        const variantId = $('[name="variant_id"]')?.val();
        const isRTS = $('[data-rts-variants]')?.data('rts-variants')?.split(',')?.includes(variantId) || false;
        const revert = () => {
          $allBtns.prop('aria-disabled', false);
          $disable.removeClass('loading');
          $btn.text(original);
        };
        const propertiesEvent = $('[name="properties[Event]"]')?.val();
        const properties = {
          ...(propertiesEvent ? {Event: propertiesEvent} : {}),
          _productId: prodObj?.productId,
          _designName: `${prodObj?.productTitle}${isRTS ? ' (In Stock)' : ''}`,
          _addToCart: `${window.location.origin}/products/${prodObj?.productHandle}?variant=${variantId}`
        };
        window.UnitMOQ.addToCart(1, properties).then(async (e) => {
          const sections = ['cart-drawer', 'cart-icon-bubble'];
          const res = await fetch(`${routes.cart_change_url}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                  line: 1,
                  quantity: 1,
                  sections,
                  sections_url: window.location.pathname
              })
          });
          const data = await res.json();
          this.cart.renderContents(data);
          revert();
        }).catch((e) => {
          console.error(e);
          revert();
        });
      }
    }
  );
}
